/**
 * `formatLayerName` returns display names with the unit tacked on after a
 * comma ("Median household income, $"). Wherever the label and the number sit
 * in separate boxes, the unit belongs with the number - but only the two units
 * that read as an affix. "offenses per 100K ppl" is a phrase and stays where
 * it is.
 */
export function splitUnit(name: string): {
  label: string;
  prefix: string;
  suffix: string;
} {
  if (name.endsWith(', $')) {
    return { label: name.slice(0, -3), prefix: '$', suffix: '' };
  }
  if (name.endsWith(', %')) {
    return { label: name.slice(0, -3), prefix: '', suffix: '%' };
  }
  return { label: name, prefix: '', suffix: '' };
}
